import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
  Typography,
  List,
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemText,
  CircularProgress,
} from '@mui/material';
import { downloadImage } from 'js/library/services/StorageManager.js';
import placeholderThumb from 'styles/assets/placeholder/placeholderThumbTriibo.png';
import { getUserOrgs } from 'js/library/utils/API/getUserOrgs.js';

import {
  trackEventMatomoElementId,
  trackEventMatomo,
  getLastUserInfo
} from 'js/library/utils/helpers';

const verifyLocalization =
  localStorage.getItem('persist:phoneInput') ? JSON.parse(localStorage.getItem('persist:phoneInput')).cellPhone.substring(
    1,
    4
  ) === ('+57' || '+59') : null;

export const HomeTriibos = (reloadOrgs) => {
  const [orgs, setOrgs] = React.useState(false);
  let timeDebounce = null;

  const { t } = useTranslation();

  const userInfo = getLastUserInfo();

  if (!orgs || reloadOrgs.orgs) {
    //setOrgs(false);

    getUserOrgs(userInfo.uId).then((result) => {
      if (result.success) {
        reloadOrgs.reloadOrgs(false);
        setOrgs(result.orgs);
      } else {
        setOrgs(null);
      }
    });
  }

  function downloadImageOnLoad(i) {
    if (orgs[i].downloaded === undefined) {
      const img = orgs[i].thumbnail.split('/');
      downloadImage(img[0], img[1])
        .then((downloadedImg) => {
          let array = [...orgs];
          array[i].downloaded = downloadedImg;

          setOrgs(array);
        })
        .catch((error) => {
          return error;
        });
    }
  }

  function scrollMatomo() {
    clearTimeout(timeDebounce);
    timeDebounce = setTimeout(() => {
      trackEventMatomo('SuasTriibos', 'scroll', 'lista', 'suas triibos');
    }, 400);
  }

  return (
    <>
      {verifyLocalization ? null : (
        <div className="home-paper-triibos">
          <Typography
            variant="body1"
            className="home-paper-triibos-title"
            style={{ color: '#6e3296', fontWeight: 600 }}
          >
            {/* TROCAR */}
            {t('home.yours_triibos')}
          </Typography>

          <div
            onScroll={() => scrollMatomo()}
            className="home-paper-list"
            style={{ maxHeight: '100%' }}
          >
            <List>
              {orgs === false || reloadOrgs.orgs ? (
                <div style={{ textAlign: 'center' }}>
                  <CircularProgress />
                </div>
              ) : orgs === null || orgs === undefined ? (
                <div style={{ padding: '0px 10px' }}>
                  <Typography variant="subtitle2" color="secondary">
                    {/* TROCAR */}
                    {t('home.suggestions_to_you')}
                  </Typography>
                </div>
              ) : orgs === null || orgs.length === 0 ? (
                <div style={{ padding: '0px 10px' }}>
                  <Typography variant="subtitle2" color="secondary">
                    {/* TROCAR */}
                    {t('home.suggestions_to_you')}
                  </Typography>
                </div>
              ) : (
                orgs.map((triibo, i) => {
                  return (
                    <Link
                      key={triibo.orgID}
                      to={{
                        pathname: '/triibos/',
                        search: '?id=' + triibo.orgID,
                        state: triibo,
                      }}
                      style={{ textDecoration: 'none' }}
                      onClick={() => {
                        trackEventMatomoElementId(
                          'SuasTriibos',
                          'tocar',
                          'triibo',
                          triibo.orgID
                        );
                      }}
                    >
                      <ListItem /* style={{margin:'0rem 2rem 0rem 1rem'}} */>
                        <ListItemAvatar>
                          <Avatar>
                            <img
                              src={
                                triibo.downloaded === undefined
                                  ? placeholderThumb
                                  : triibo.downloaded
                              }
                              width="100%"
                              alt="thumb"
                              onLoad={() => downloadImageOnLoad(i)}
                            />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          style={{ color: 'black' }}
                          primary={triibo.name}
                        />
                      </ListItem>
                    </Link>
                  );
                })
              )}
            </List>
          </div>
        </div>
      )}
    </>
  );
};

export default HomeTriibos;
